import axiosApi from "api/root.api";

// 上傳 ScanKit 模型的背景圖（後端 3.11，/scan/editor 路徑）。成功時 bgImage 換成新圖、舊圖刪除；
// 顯示與否由 updateModel 的 bgImageSwitch 控制。header 用單次請求的設定，不改 axios 共用預設值
export const uploadBackground = async (file, token, projectId, modelId) => {
  const urlEnd = `/scan/editor/project/v1/${projectId}/${modelId}/uploadBackground`;
  const body = new FormData();
  body.append("file", file);
  const response = await axiosApi.post(urlEnd, body, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
